import React, { useState, useEffect, useRef } from "react";
import { NavLink, Link } from "react-router-dom";

export const NAV_LINKS = [
  { to: "/about", label: "About" },
  { to: "/aky", label: "Aky" },
  { to: "/lead-ai", label: "Lead.ai" },
  { to: "/research", label: "Research" },
  { to: "/contact", label: "Contact" },
];

const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]/g, "-");

export const Wordmark = ({ height = 26, testId = "wordmark-link" }) => (
  <Link to="/" className="wordmark" data-testid={testId} aria-label="Syni.ai home">
    <img src="/logo.png" alt="Syni.ai" height={height} width={Math.round(height * 3.736)} style={{ display: "block" }} />
  </Link>
);

export const Nav = () => {
  const [open, setOpen] = useState(false);
  const overlayRef = useRef(null);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === "Escape" && setOpen(false);
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open]);

  return (
    <header className="nav" data-testid="site-nav">
      <div className="container-syni nav-inner">
        <Wordmark />
        <nav className="nav-links hidden md:flex" aria-label="Primary" data-testid="desktop-nav-links">
          {NAV_LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              className={({ isActive }) => `nav-link${isActive ? " active" : ""}`}
              data-testid={`nav-link-${slug(l.label)}`}
            >
              {l.label}
            </NavLink>
          ))}
        </nav>
        <button
          type="button"
          className="menu-trigger inline-flex md:hidden"
          aria-expanded={open}
          aria-controls="mobile-menu"
          onClick={() => setOpen(true)}
          data-testid="menu-open-button"
        >
          Menu
        </button>
      </div>

      {open && (
        <div
          ref={overlayRef}
          className="menu-overlay"
          id="mobile-menu"
          role="dialog"
          aria-modal="true"
          aria-label="Menu"
          data-testid="mobile-menu-overlay"
          onMouseDown={(e) => e.target === overlayRef.current && setOpen(false)}
        >
          <div className="container-syni menu-overlay-top">
            <Wordmark testId="mobile-wordmark-link" />
            <button type="button" className="menu-trigger inline-flex" onClick={() => setOpen(false)} data-testid="menu-close-button">
              Close
            </button>
          </div>
          <div className="container-syni">
            <nav className="menu-overlay-links" aria-label="Mobile primary">
              {NAV_LINKS.map((l) => (
                <NavLink
                  key={l.to}
                  to={l.to}
                  className={({ isActive }) => `menu-overlay-link${isActive ? " active" : ""}`}
                  onClick={() => setOpen(false)}
                  data-testid={`mobile-nav-link-${slug(l.label)}`}
                >
                  {l.label}
                </NavLink>
              ))}
            </nav>
          </div>
        </div>
      )}
    </header>
  );
};

export default Nav;
